import { Outlet, useSearchParams } from "react-router-dom";
import useMediaQuery from "../../../hooks/useMediaQuery";
import DesktopLayout from "../../organisms/layouts/app/DesktopLayout";
import MobileLayout from "../../organisms/layouts/app/MobileLayout";
import TabletLayout from "../../organisms/layouts/app/TabletLayout";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const AppLayout = () => {
  const { i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  let countryCode = localStorage.getItem("countryCode");
  useEffect(() => {
    const country = searchParams.get("country");
    if (countryCode == null || countryCode === "null") {
      localStorage.setItem("countryCode", "TR");
    }
    if (country?.toUpperCase() === "DE") {
      localStorage.setItem("countryCode", "DE");
      i18n.changeLanguage("de");
    }
  }, []);
  const isDesktop = useMediaQuery("(min-width: 1200px)");
  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1199px)");
  if (isDesktop) {
    return (
      <DesktopLayout>
        <Outlet />
      </DesktopLayout>
    );
  }

  if (isTablet) {
    return (
      <TabletLayout>
        <Outlet />
      </TabletLayout>
    );
  }

  return (
    <MobileLayout>
      <Outlet />
    </MobileLayout>
  );
};

export default AppLayout;
